import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, Button} from 'kpc';

var _$tmp0 = {
    'style': 'margin-left: 10px;'
};
var _$tmp1 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'id': 'welcome-btn',
                'children': '欢迎页面'
            }),
            _$cc(Button, {
                'id': 'feature-btn',
                'style': 'margin-left: 20px;',
                'children': '功能介绍'
            }),
            _$cc(Button, {
                'id': 'finish-btn',
                'style': 'margin-left: 20px;',
                'children': '完成设置'
            })
        ], 4 /* HasNonKeyedChildren */, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'data': this.get('tourData'),
            'doneText': '完成',
            'ev-finish': this.close,
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', [
            _$cc(Button, {
                'type': 'primary',
                'ev-click': this.startTour,
                'children': '\n            开始自定义按钮引导\n        '
            }),
            _$ce(2, 'span', [
                _$ct('\n            当前步骤: '),
                this.get('currentStep') >= 0 ? this.get('currentStep') + 1 : '未启动'
            ], 0 /* UnknownChildren */, null, _$tmp0)
        ], 4 /* HasNonKeyedChildren */, null, _$tmp1)
    ], 4 /* HasNonKeyedChildren */);
};